import { PaletteRenderer } from './PaletteRenderer';

export const PaletteModule = {
  __init__: ['palette'],
  palette: ['type', PaletteRenderer],
};
